// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-global-boundary .ant-result>.ant-result-content{background-color:rgba(0,0,0,0)}.cvat-global-boundary .cvat-global-boundary-error-field{color:red}\n", ""]);
// Exports
module.exports = exports;
